import styles from './Footer.module.scss';

import { getCurrentYear } from '@/utils/getCurrentYear';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      <div className={styles.firstLine}>
        <a href="https://macpaw.com/clearvpn" className={styles.logo}>
          <img
            src="/images/logo-horizontal-white.png"
            width="87px"
            height="24px"
            alt=""
            srcSet="/images/logo-horizontal-white@2x.png"
          />
        </a>

        <div className={styles.links}>
          <a href="https://clearvpn.com/terms-of-service">Terms & Conditions</a>
          <a href="https://clearvpn.com/privacy-policy">Privacy Policy</a>
          <a href="https://support.clearvpn.com/hc/requests/new">Contact support</a>
        </div>

        <a href="https://macpaw.com" className={styles.macpaw}>
          <span>Product by</span>
          <img
            src="/images/macpaw-logo.png"
            srcSet="/images/macpaw-logo@2x.png 2x"
            width="112px"
            height="23px"
            alt=""
          />
        </a>
      </div>

      <div className={styles.secondLine}>ClearVPN © {getCurrentYear()}. All rights are reserved</div>
    </div>
  </footer>
);

export default Footer;
